import { CARTEIRA_URL, REACTCORE_URL } from "domain/infra/data/env";
import { CarteiraProps } from "./carteiraProps";
import { DomainConstants } from "domain/infra/data/domainConstants";

class CarteiraConstants extends DomainConstants {
  public apiCarteira: CarteiraProps;

  constructor() {
    super(1000);

    const api_carteira_info = {
      reactCoreUrl: REACTCORE_URL,
      carteiraUrl: CARTEIRA_URL
    } as CarteiraProps;

    this.apiCarteira = {
      ...this.apiDomain,
      carteira: {
        
        depositoPix: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/carteira/${carteiraId}/deposito/pix`,
        pixCheckSSE: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/carteira/${carteiraId}/deposito/pix-check-SSE`,
        simularPix_DEV: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/carteira/${carteiraId}/deposito/SimularPix_Dev`,
        simularBoleto_DEV: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/carteira/${carteiraId}/deposito/SimularBoleto_Dev`,
        depositoDebito: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/carteira/${carteiraId}/deposito/debito`,
        depositoCredito: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/carteira/${carteiraId}/deposito/credito`,
        depositoBoleto: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/carteira/${carteiraId}/deposito/Boleto`,
        calcularImposto: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/carteira/${carteiraId}/Pagamento/Calcular-Imposto`,
        getMeioPagamento: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/carteira/${carteiraId}/Pagamento/Meios-Pagamento`,
        validarPix: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/carteira/${carteiraId}/Pagamento/VerificarPix`,
        pagar: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/carteira/${carteiraId}/Pagamento/Pagar`,
        transferirPix: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/Carteira/${carteiraId}/Pagamento/Transferir`,
        getExtrato: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/carteira/${carteiraId}/Extrato/Range`,
        getPagamento: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/Carteira/${carteiraId}/Extrato/Pagamento/Agrupado`,
        getPagamentoDetalhado: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/Carteira/${carteiraId}/Extrato/Pagamento/Detalhado`,
        getPagamentoDetalhadoByID: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/Carteira/${carteiraId}/Extrato/Pagamento/DetalhadoById`,
        getBoletos: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/carteira/${carteiraId}/Deposito/Boletos`,
        GetBoletoSemelhante: (carteiraId, valor) => `${api_carteira_info.carteiraUrl}/carteira/${carteiraId}/Deposito/BoletoSemelhante?valorBoleto=${valor}`
      },
      pagamento: {
        get: `${api_carteira_info.carteiraUrl}/pagamento/get`
      },
      aprovarPedido: {
        aprovarResgate: `${api_carteira_info.reactCoreUrl}/campanhapedidoresgate/AlterarStatus`,
        reprovarResgate: `${api_carteira_info.reactCoreUrl}/campanhapedidoresgate/ReprovarPedido`
      },
      carteiraAdmin: {
        getCarteiraPermissao: (carteiraId: number, usuarioId:number) => `${api_carteira_info.carteiraUrl}/Carteira/${carteiraId}/carteiraAdmin/permissoes/${usuarioId}`,
        getUsuarioCarteira: (carteiraId: number) => `${api_carteira_info.carteiraUrl}/Carteira/${carteiraId}/carteiraAdmin/usuarios`,
        atualizarPermissao: (carteiraId: number, usuarioId: number) => `${api_carteira_info.carteiraUrl}/Carteira/${carteiraId}/CarteiraAdmin/Permissoes/${usuarioId}`  
      },
      carteiraFilialUsuario: {
        getFilialEmpresaByEmpresaId: (empresaId: number) => `${api_carteira_info.carteiraUrl}/FilialUsuario/GetFilialEmpresaByEmpresaId?Empresaid=${empresaId}`
      }} as CarteiraProps
  }
}

export default new CarteiraConstants();
